/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Governance_TitleInputs */

const en_governance_title = /** @type {(inputs: Governance_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Governance`)
};

/**
* | output |
* | --- |
* | "Governance" |
*
* @param {Governance_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const governance_title = /** @type {((inputs?: Governance_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Governance_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_governance_title(inputs)
});